// Created by jarongallo at 3/31/21
import React, { useEffect, useState } from 'react';
import './styles';
import UIListInputRow from '../../../../../components/UI/UIListInputRow';
import { UI_LABELED_INPUT_BUTTON_TYPE, UI_LABELED_INPUT_NUMBER_TYPE } from '../../../../../components/UI/UILabeledInput/config';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import Queries from '../../../../../utils/API/Queries';
import { toast } from 'react-toastify';
import { GET_TECHNICIAN_ADMIN } from './queries';
import * as strings from './strings';
import { camelCaseToSentence } from '../../../../../utils/Helpers/StringHelpers';
import { allowInvoicing, claimServiceDelayLabel } from './strings';
import { UI_ICON_BUTTON_CANCEL_TYPE, UI_ICON_BUTTON_FILL_TYPE } from '../../../../../components/UI/UIIconButton/config';

export default function IndividualTechnicianAdmin({ technicianId }: IndividualTechnicianAdminProps) {
	const [isSavingAllowInvoicing, setIsSavingAllowInvoicing] = useState<boolean>(false);
	const [claimServiceDelay, setClaimServiceDelay] = useState<number>();
	const [technician, setTechnician] = useState<UserType>();

	const [updateTechnicianApi] = useMutation(Queries.UPDATE_USER_MUTATION, {
		onError: (error) => toast.error(strings.errorUpdatingUser(error.message))
	});

	const [getTechnician, { data: technicianData }] = useLazyQuery(GET_TECHNICIAN_ADMIN, {
		variables: { id: technicianId }
	});

	useEffect(() => {
		(async () => {
			await getTechnician();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (technicianData) {
				const fetchedTechnician: UserType = technicianData['user'];
				setClaimServiceDelay(fetchedTechnician.claimServiceDelay);
				setTechnician(fetchedTechnician);
			}
		})();
	}, [technicianData]);

	if (!technician) return null;

	const updateTechnician = async (key: string, value: any) => {
		const response = await updateTechnicianApi({ variables: { id: technicianId, [key]: value } });
		if (response.data['updateUser']) {
			await getTechnician();
			toast.success(strings.updateUserSuccess(camelCaseToSentence(key)));
		} else {
			toast.error(strings.errorUpdatingUser(`User update failed.`));
		}
	};

	const onSaveAllowInvoicing = async () => {
		setIsSavingAllowInvoicing(true);
		await updateTechnician('allowInvoicing', !technician.allowInvoicing);
		setIsSavingAllowInvoicing(false);
	};

	return (
		<div className='individualTechnician__content'>
			<UIListInputRow
				label={claimServiceDelayLabel}
				type={UI_LABELED_INPUT_NUMBER_TYPE}
				savedValue={technician.claimServiceDelay}
				onChangeNumberValue={setClaimServiceDelay}
				onSave={() => updateTechnician('claimServiceDelay', claimServiceDelay)}
				value={claimServiceDelay}
				placeholder={strings.claimServiceDelayPlaceholder}
			/>
			<UIListInputRow
				dark
				className='UIBtn-top'
				isLoading={isSavingAllowInvoicing}
				label={strings.allowInvoicingLabel}
				type={UI_LABELED_INPUT_BUTTON_TYPE}
				buttonType={technician.allowInvoicing ? UI_ICON_BUTTON_CANCEL_TYPE : UI_ICON_BUTTON_FILL_TYPE}
				value={technician.allowInvoicing ? strings.disableInvoicing : strings.allowInvoicing}
				onClick={onSaveAllowInvoicing}
			/>
		</div>
	);
}
